import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../";

const BusinessInfoModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Business Integration Information"
      size="md"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500/10">
              <svg
                className="h-5 w-5 text-blue-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <div className="flex-1">
            <h3 className="mb-2 text-lg font-medium text-white">
              Connect Your POS System
            </h3>
            <p className="leading-relaxed text-gray-300">
              Connect with any of our available integrations with a few steps.
              Open the store where you want to connect your POS to our system.
              Configure the integration settings with your own keys and sync
              your products and stores to your POS or to our dashboard.
            </p>
            <p className="mt-3 leading-relaxed text-gray-300">
              <span className="font-medium text-white">Need Help?</span> Our
              support team is available to help you set up integrations and
              answer any questions you may have.
            </p>
          </div>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            onClick={onClose}
            className="rounded-md border border-gray-700 bg-gray-800 px-4 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
          >
            Close
          </button>
          <button
            onClick={() => {
              // Navigate to support page using React Router
              navigate("/support");
            }}
            className="rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
          >
            Contact Support
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BusinessInfoModal;
